import axiosInstance from "../../../http-common";
import { v4 } from "uuid";
import { logout_if_403 } from "../../../util";

export const getErrorMessage = (error) => {
  if (error instanceof Error) return error.message;
  return String(error);
};
export const load_sample_receiver_data_from_backend = async (
  data,
  setData,
  tabName
) => {
  // console.log("loading po from backend");
  try {
    const result = await axiosInstance.get(
      `v1/qc/open_po_new/${tabName}/?user=sample_receiver`
    );
    console.log(result);
    if (result.data) {
      const tableData = result?.data?.data?.map((item) => ({
        ...item,
        id: v4(),
      }));
      if (
        result["data"]?.["data"] &&
        setData &&
        typeof setData === "function"
      ) {
        setData(tableData);
      }
    }
  } catch (error) {
    console.log({ error });
    logout_if_403(error);
    const err = getErrorMessage(error);
    console.log({ error: err });
    // dispatch(po_load_failure_action(err));
  }
};

// // to edit
export const edit_sample_receiver_schedule = async (updatedRow, category, set_open_snackbar_with_message = () => { }) => {
  // console.log(updatedRow, category);
  const { ...update_fields } = updatedRow;
  let receiving_date_by_qc = null;
  if (update_fields.receiving_date_by_qc instanceof Date) {
    receiving_date_by_qc = update_fields.receiving_date_by_qc.toISOString();
  }
  // console.log(receiving_date_by_qc, updatedRow);

  const data = JSON.stringify({
    ...update_fields,
    receiving_date_by_qc,
  });
  console.log(data);
  const response = await axiosInstance.patch(
    `/v1/qc/open_po_new/${category}/`,
    data
  );
  const result = response.data.status;
  // const result = true;
  console.log({ result });
  if (result === "success") {
    set_open_snackbar_with_message({
      message: response?.data?.message,
      open: true,
      severity: "success"
    });
    return true;
  }
  else return false;
};

// to get hidden columns
export const getHiddenColumnsSampleReceiver = async (
  data,
  setData,
  setLoading
) => {
  setLoading(true);
  try {
    const result = await axiosInstance.get(`v1/qc/get_hidden_fields`);
    console.log(result);
    if (result.data) {
      if (
        result["data"]?.["data"] &&
        setData &&
        typeof setData === "function"
      ) {
        const columnsData = result?.data?.data?.open_po;
        if (columnsData && Object.keys(columnsData).length > 0) {
          const hiddenColumns = columnsData.reduce((acc, columnName) => {
            acc[columnName] = false;
            return acc;
          }, {});
          setData(hiddenColumns);
        } else {
          console.log("Columns data is empty.");
          setData({});
        }
      }
    }
  } catch (error) {
    console.log({ error });
    const err = getErrorMessage(error);
    console.log({ error: err });
  } finally {
    setLoading(false);
  }
};
